import { ServiceChargeUtil } from '../../service-charge';
export function round(number, fraction = 10) {
    return +(+number).toFixed(fraction);
}
export function toCents(price) {
    return round(price * 100, 0);
}
export function getTotalAmountWithoutTips(order, inCents = false) {
    var _a, _b;
    const deliveryTips = ((_b = (_a = ServiceChargeUtil.getDeliveryTip(order)) === null || _a === void 0 ? void 0 : _a.total) === null || _b === void 0 ? void 0 : _b.money) || 0;
    const totalWithoutTips = order.total - order.total_gratuity + deliveryTips;
    return inCents ? toCents(totalWithoutTips) : round(totalWithoutTips, 2);
}
export function getTipsAmount(order, inCents = false) {
    var _a, _b;
    const deliveryTips = ((_b = (_a = ServiceChargeUtil.getDeliveryTip(order)) === null || _a === void 0 ? void 0 : _a.total) === null || _b === void 0 ? void 0 : _b.money) || 0;
    const tipsAmount = order.total_gratuity - deliveryTips;
    return inCents ? toCents(tipsAmount) : round(tipsAmount, 2);
}
export function getTotalAmountWithTipsAndDelivery(order, inCents = false) {
    var _a, _b, _c, _d, _e, _f;
    const deliveryTips = (_c = (_b = (_a = ServiceChargeUtil.getDeliveryTip(order)) === null || _a === void 0 ? void 0 : _a.total) === null || _b === void 0 ? void 0 : _b.money) !== null && _c !== void 0 ? _c : 0;
    const deliveryFee = (_f = (_e = (_d = ServiceChargeUtil.getDeliveryFee(order)) === null || _d === void 0 ? void 0 : _d.total) === null || _e === void 0 ? void 0 : _e.money) !== null && _f !== void 0 ? _f : 0;
    const tipsAmount = getTipsAmount(order);
    const total = deliveryTips + deliveryFee + tipsAmount;
    return inCents ? toCents(total) : round(total, 2);
}
export function getTotalAmountWithoutTipsAndDelivery(order, inCents = false) {
    const total = order.total - getTotalAmountWithTipsAndDelivery(order);
    return inCents ? toCents(total) : round(total, 2);
}
export function getFulfillmentMinutes(schedulingInfo, options) {
    const { prepTime = 0, deliveryTime = 0, delayTime = 0 } = schedulingInfo;
    const { pickupTimeDelta = 0, deliveryTimeDelta = 0, includeDelay = false } = options || {};
    const prepTimeDelay = includeDelay ? delayTime : 0;
    return {
        preparedIn: round(prepTime + pickupTimeDelta + prepTimeDelay),
        fulfilledIn: round(prepTime + deliveryTime + deliveryTimeDelta + prepTimeDelay),
    };
}
//# sourceMappingURL=calculations.utils.js.map